export default __webpack_public_path__ + "static/media/optOutIcon.f5862ce7.svg";